export enum NotificationStatusEnum {
  NEW = '00000199-1000-0000-0000-000000000001',
  READ = '00000199-1000-0000-0000-000000000002'
}
